import { render } from "./ConfirmationModal.vue?vue&type=template&id=01496746&scoped=true"
import script from "./ConfirmationModal.vue?vue&type=script&lang=js"
export * from "./ConfirmationModal.vue?vue&type=script&lang=js"

import "./ConfirmationModal.vue?vue&type=style&index=0&id=01496746&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01496746"]])

export default __exports__